var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details',{staticClass:"details"},[(_vm.label && _vm.label != '')?_c('summary',{staticClass:"button button-primary--small"},[_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"details--content"},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381f2e4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Details.vue
// module id = UBm2
// module chunks = 0